var _style, _radialGradient, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _path24, _path25, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 841.9 595.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}.st2,.st3{opacity:.57;fill:#fff}.st3{opacity:.19}")), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 417.945,
    cy: 437.633,
    r: 1062.056,
    gradientTransform: "matrix(1 0 0 .3 0 306.343)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#f39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#c88d44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#918371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#607786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#336e90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#006793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#006594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#004a71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#002641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00152e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M0 0h841.9v595.3H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 29.2,
    r: 1.3,
    className: "st1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2,
    cy: 13,
    r: 0.6,
    className: "st1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.8,
    cy: 34.2,
    r: 0.6,
    className: "st1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.8,
    cy: 90.4,
    r: 0.6,
    className: "st1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.2,
    cy: 15.4,
    r: 0.6,
    className: "st1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.7,
    cy: 25.3,
    r: 0.6,
    className: "st1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.8,
    cy: 49.2,
    r: 0.6,
    className: "st1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.6,
    cy: 63.4,
    r: 0.6,
    className: "st1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.1,
    cy: 2.2,
    r: 0.6,
    className: "st1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.6,
    cy: 68.6,
    r: 0.6,
    className: "st1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7,
    cy: 1.5,
    r: 0.6,
    className: "st1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.7,
    cy: 46,
    r: 0.6,
    className: "st1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.8,
    r: 1.3,
    className: "st1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.4,
    cy: 58.4,
    r: 1.3,
    className: "st1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.4,
    cy: 94.8,
    r: 1.3,
    className: "st1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.3,
    cy: 8.5,
    r: 1.3,
    className: "st1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.4,
    cy: 26.6,
    r: 1.3,
    className: "st1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.3,
    cy: 61.4,
    r: 1.3,
    className: "st1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.2,
    cy: 47.3,
    r: 1.3,
    className: "st1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.9,
    cy: 49.3,
    r: 1.3,
    className: "st1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 668.6,
    cy: 33.1,
    r: 0.6,
    className: "st1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.2,
    cy: 54.3,
    r: 0.6,
    className: "st1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 790.6,
    cy: 35.5,
    r: 0.6,
    className: "st1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.1,
    cy: 45.5,
    r: 0.6,
    className: "st1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.2,
    cy: 69.3,
    r: 0.6,
    className: "st1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 819,
    cy: 83.5,
    r: 0.6,
    className: "st1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 748.5,
    cy: 22.3,
    r: 0.6,
    className: "st1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 88.7,
    r: 0.6,
    className: "st1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.2,
    cy: 21.6,
    r: 0.6,
    className: "st1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.1,
    cy: 66.1,
    r: 0.6,
    className: "st1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.5,
    cy: 50.6,
    r: 0.6,
    className: "st1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.9,
    cy: 29.9,
    r: 1.3,
    className: "st1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.9,
    cy: 78.5,
    r: 1.3,
    className: "st1"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 796.7,
    cy: 28.6,
    r: 1.3,
    className: "st1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 729.8,
    cy: 46.8,
    r: 1.3,
    className: "st1"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.8,
    cy: 81.6,
    r: 1.3,
    className: "st1"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 827.6,
    cy: 67.4,
    r: 1.3,
    className: "st1"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.8,
    cy: 39.3,
    r: 1.3,
    className: "st1"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 23.1,
    r: 0.6,
    className: "st1"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.1,
    cy: 44.3,
    r: 0.6,
    className: "st1"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.1,
    cy: 100.5,
    r: 0.6,
    className: "st1"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.5,
    cy: 25.5,
    r: 0.6,
    className: "st1"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 35.4,
    r: 0.6,
    className: "st1"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.1,
    cy: 59.3,
    r: 0.6,
    className: "st1"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 496,
    cy: 73.5,
    r: 0.6,
    className: "st1"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.5,
    cy: 12.3,
    r: 0.6,
    className: "st1"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 78.7,
    r: 0.6,
    className: "st1"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.1,
    cy: 11.6,
    r: 0.6,
    className: "st1"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 56.1,
    r: 0.6,
    className: "st1"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.9,
    cy: 19.9,
    r: 1.3,
    className: "st1"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.8,
    cy: 68.5,
    r: 1.3,
    className: "st1"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 473.7,
    cy: 18.6,
    r: 1.3,
    className: "st1"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 406.7,
    cy: 36.7,
    r: 1.3,
    className: "st1"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.7,
    cy: 71.5,
    r: 1.3,
    className: "st1"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.6,
    cy: 57.4,
    r: 1.3,
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m440.2 358.2-.5-4.1-2.9-21.2-.5-4.1-2.9-21.2-.5-4.1-4.6-34.1h-21.8l-4.6 34.1-.5 4.1-2.9 21.2-.5 4.1-2.9 21.2-.5 4.1-4.5 33.5 5.5-2.9 21.9-15.3 21.9 15.3 5.5 2.9-4.7-33.5zm-6.9-24 2.7 18.3-16.4-10 13.7-8.3zm-5.9-26.6-10.1 7.8-10.1-7.8h20.2zm-20-4.1 9.8-10.3 9.8 10.3h-19.6zm23.1 25.3H404l13.2-10.3 13.3 10.3zm.2 4.1-13.5 8.2-13.5-8.2h27zm3.2 21.2h-33.2l16.6-10.1 16.6 10.1zm-1.6-27.1-13-10.1 10.3-8 2.7 18.1zm-3.8-25.6-9.5-10 7-7.4 2.5 17.4zm-4.6-18.9-6.7 7.1-6.7-7.1h13.4zm-15.3 1.6 6.9 7.3-9.5 10 2.6-17.3zm-3.7 24.9 10.3 8-13 10.1 2.7-18.1zm-3.7 25.2 13.7 8.3-16.4 10 2.7-18.3zm-7.8 52.9 4.1-27.5 17.6 12.3-21.7 15.2zm6.4-28.9h34.9l-17.4 12.2-17.5-12.2zm19.6 13.7 17.6-12.3 4.1 27.5-21.7-15.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.9 247.1v5.8h-2.4v148.4H413V252.9h-2.4v-5.8zM653.4 376.8l-.4-2.7-1.9-14-.4-2.7-1.9-14-.4-2.7-3-22.4h-14.3l-3 22.4-.4 2.7-1.9 14-.4 2.7-1.9 14-.4 2.7-3 22 3.6-1.9 14.4-10.1 14.4 10.1 3.6 1.9-2.7-22zm-4.5-15.7 1.8 12-10.8-6.6 9-5.4zm-3.9-17.6-6.7 5.2-6.7-5.2H645zm-13.1-2.6 6.4-6.8 6.5 6.8h-12.9zm15.2 16.6h-17.4l8.7-6.7 8.7 6.7zm.1 2.7-8.9 5.4-8.9-5.4h17.8zm2.1 14h-21.9l10.9-6.7 11 6.7zm-1.1-17.9-8.5-6.6 6.8-5.3 1.7 11.9zm-2.5-16.8-6.3-6.6 4.6-4.8 1.7 11.4zm-3-12.5-4.4 4.7-4.4-4.7h8.8zm-10.1 1.1 4.6 4.8-6.2 6.6 1.6-11.4zm-2.4 16.4 6.8 5.3-8.5 6.6 1.7-11.9zm-2.4 16.6 9 5.5-10.8 6.6 1.8-12.1zm-5.2 34.7 2.7-18.1 11.6 8.1-14.3 10zm4.3-19h23l-11.5 8-11.5-8zm12.9 9 11.6-8.1 2.7 18.1-14.3-10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M642.7 303.7v3.9h-1.6v97.6h-5.5v-97.6H634v-3.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m656 379.4-.4-3.1-2.2-16.4-.4-3.1-2.2-16.4-.4-3.1-3.6-26.3H630l-3.6 26.3-.4 3.1-2.2 16.4-.4 3.1-2.2 16.4-.4 3.1-3.5 25.8 4.3-2.3 16.9-11.8 16.9 11.8 4.3 2.3-3.7-25.8zm-5.2-18.5 2.1 14.1-12.6-7.7 10.5-6.4zm-4.6-20.5-7.8 6-7.8-6h15.6zm-15.4-3.1 7.6-8 7.6 8h-15.2zm17.8 19.5h-20.4l10.2-7.9 10.2 7.9zm.2 3.1-10.4 6.3-10.4-6.3h20.8zm2.4 16.4h-25.6l12.8-7.8 12.8 7.8zm-1.3-20.9-10-7.8 8-6.2 2 14zm-2.9-19.8-7.4-7.7 5.4-5.7 2 13.4zm-3.5-14.6-5.2 5.5-5.2-5.5h10.4zm-11.8 1.3 5.3 5.6-7.3 7.7 2-13.3zm-2.9 19.2 8 6.2-10 7.8 2-14zm-2.8 19.4 10.6 6.4L624 375l2-14.1zm-6.1 40.8 3.1-21.2 13.6 9.5-16.7 11.7zm5-22.3h26.9l-13.5 9.4-13.4-9.4zM640 390l13.6-9.5 3.1 21.2L640 390zM129.2 387.5l-.3-2.2-1.6-11.7-.3-2.2-1.6-11.7-.3-2.2-2.5-18.8h-12l-2.5 18.8-.3 2.2-1.6 11.7-.3 2.2-1.6 11.7-.3 2.2-2.5 18.5 3.1-1.6 12.1-8.4 12.1 8.4 3.1 1.6-2.7-18.5zm-3.7-13.3 1.5 10.1-9-5.5 7.5-4.6zm-3.3-14.7-5.6 4.3-5.6-4.3h11.2zm-11-2.2 5.4-5.7 5.4 5.7h-10.8zm12.7 14h-14.6l7.3-5.7 7.3 5.7zm.1 2.2-7.4 4.5-7.4-4.5H124zm1.8 11.7h-18.3l9.2-5.6 9.1 5.6zm-.9-14.9-7.2-5.5 5.7-4.4 1.5 9.9zm-2.1-14.2-5.3-5.5 3.8-4.1 1.5 9.6zm-2.5-10.4-3.7 3.9-3.7-3.9h7.4zm-8.5.9 3.8 4-5.2 5.5 1.4-9.5zm-2 13.7 5.7 4.4-7.2 5.5 1.5-9.9zm-2.1 13.9 7.5 4.6-9 5.5 1.5-10.1zm-4.3 29.2 2.2-15.2 9.7 6.8-11.9 8.4zm3.6-15.9h19.2l-9.6 6.7-9.6-6.7zm10.8 7.5 9.7-6.8 2.2 15.2-11.9-8.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 326.2v3.2h-1.4v81.9h-4.6v-81.9h-1.4v-3.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m131.4 389.6-.4-2.6-1.9-13.7-.4-2.6-1.9-13.7-.4-2.6-3-22h-14.1l-3 22-.4 2.6-1.9 13.7-.4 2.6-1.9 13.7-.4 2.6-2.9 21.6 3.6-1.9 14.2-9.9 14.2 9.9 3.6 1.9-2.6-21.6zm-4.4-15.5 1.7 11.8-10.6-6.4 8.9-5.4zm-3.9-17.2-6.5 5.1-6.5-5.1h13zm-12.8-2.6 6.3-6.7 6.4 6.7h-12.7zm14.9 16.3H108l8.6-6.6 8.6 6.6zm.1 2.7-8.7 5.3-8.7-5.3h17.4zm2.1 13.7h-21.5l10.7-6.5 10.8 6.5zm-1.1-17.5-8.4-6.5 6.7-5.2 1.7 11.7zm-2.4-16.6-6.2-6.5 4.5-4.8 1.7 11.3zm-3-12.2-4.3 4.6-4.4-4.6h8.7zm-9.9 1 4.5 4.7-6.1 6.5 1.6-11.2zm-2.4 16.1 6.7 5.2-8.4 6.5 1.7-11.7zm-2.4 16.3 8.8 5.4-10.6 6.4 1.8-11.8zm-5 34.2 2.6-17.8 11.4 8-14 9.8zm4.1-18.7h22.6l-11.3 7.9-11.3-7.9zm12.7 8.9 11.4-8 2.6 17.8-14-9.8zM270.4 389.1l-.2-1.4-1-7.4-.2-1.4-1-7.4-.2-1.4-1.6-11.8h-7.5l-1.6 11.8-.2 1.4-1 7.4-.2 1.4-1 7.4-.2 1.4-1.6 11.6 1.9-1 7.6-5.3 7.6 5.3 1.9 1-1.5-11.6zm-2.3-8.3.9 6.3-5.7-3.5 4.8-2.8zm-2.1-9.2-3.5 2.7-3.5-2.7h7zm-6.9-1.4 3.4-3.6 3.4 3.6h-6.8zm8 8.8h-9.2l4.6-3.6 4.6 3.6zm.1 1.4-4.7 2.8-4.7-2.8h9.4zm1.1 7.3h-11.5l5.8-3.5 5.7 3.5zm-.6-9.3-4.5-3.5 3.6-2.8.9 6.3zm-1.3-8.9-3.3-3.5 2.4-2.5.9 6zm-1.6-6.6-2.3 2.5-2.3-2.5h4.6zm-5.3.6 2.4 2.5-3.3 3.5.9-6zm-1.3 8.6 3.6 2.8-4.5 3.5.9-6.3zm-1.3 8.7 4.7 2.9-5.7 3.5 1-6.4zm-2.7 18.3 1.4-9.5 6.1 4.3-7.5 5.2zm2.3-10h12.1l-6 4.2-6.1-4.2zm6.8 4.8 6.1-4.3 1.4 9.5-7.5-5.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.8 350.7v2h-.8v51.4h-3v-51.4h-.8v-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m271.8 390.5-.2-1.6-1.2-8.6-.2-1.6-1.2-8.7-.2-1.6-1.9-13.8h-8.8l-1.9 13.8-.2 1.6-1.2 8.6-.2 1.6-1.2 8.6-.2 1.6-1.8 13.6 2.3-1.2 8.9-6.2 8.9 6.2 2.3 1.2-2-13.5zm-2.8-9.7 1.1 7.4-6.7-4 5.6-3.4zm-2.4-10.8-4.1 3.2-4.1-3.2h8.2zm-8.1-1.7 4-4.2 4 4.2h-8zm9.4 10.3h-10.8l5.4-4.2 5.4 4.2zm.1 1.6-5.5 3.3-5.5-3.3h11zm1.3 8.7h-13.5l6.7-4.1 6.8 4.1zm-.7-11-5.3-4.1 4.2-3.2 1.1 7.3zm-1.5-10.5-3.9-4.1 2.8-3 1.1 7.1zm-1.9-7.6-2.7 2.9-2.7-2.9h5.4zm-6.2.6 2.8 3-3.8 4.1 1-7.1zm-1.5 10.1 4.2 3.2-5.3 4.1 1.1-7.3zm-1.5 10.3 5.6 3.4-6.7 4 1.1-7.4zm-3.2 21.4 1.6-11.2 7.2 5-8.8 6.2zm2.6-11.7h14.2l-7.1 4.9-7.1-4.9zm8 5.6 7.2-5 1.6 11.2-8.8-6.2zM335 374.5l-.3-2.5-1.8-13.2-.3-2.5-1.8-13.2-.3-2.5-2.9-21.2H314l-2.9 21.2-.3 2.5-1.8 13.2-.3 2.5-1.8 13.2-.3 2.5-2.8 20.8 3.5-1.8 13.6-9.5 13.6 9.5 3.5 1.8-3-20.8zm-4.2-14.9 1.7 11.4-10.2-6.2 8.5-5.2zM327 343l-6.3 4.9-6.3-4.9H327zm-12.4-2.5 6.1-6.4 6.1 6.4h-12.2zm14.4 15.8h-16.5l8.2-6.4 8.3 6.4zm.1 2.5-8.4 5.1-8.4-5.1h16.8zm2 13.2h-20.7l10.3-6.3 10.4 6.3zm-1-16.8-8.1-6.3 6.4-5 1.7 11.3zm-2.4-16-5.9-6.2 4.3-4.6 1.6 10.8zm-2.8-11.8-4.2 4.4-4.2-4.4h8.4zm-9.6 1 4.3 4.5-5.9 6.2 1.6-10.7zm-2.2 15.5 6.4 5-8.1 6.3 1.7-11.3zm-2.4 15.7 8.5 5.2L309 371l1.7-11.4zm-4.8 32.9 2.5-17.1 11 7.7-13.5 9.4zm4-18h21.7l-10.9 7.6-10.8-7.6zm12.2 8.6 11-7.7 2.5 17.1-13.5-9.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.9 305.4v3.6h-1.5v92.4h-5.3V309h-1.5v-3.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m337.5 377-.4-3-2.1-15.5-.4-3-2.1-15.5-.4-3-3.4-24.9h-15.9l-3.4 24.9-.4 3-2.1 15.5-.4 3-2.1 15.5-.4 3-3.3 24.4 4-2.1 16-11.2 16 11.2 4 2.1-3.2-24.4zm-5-17.5 2 13.4-12-7.3 10-6.1zm-4.4-19.4-7.4 5.7-7.4-5.7h14.8zm-14.5-3 7.2-7.6 7.2 7.6h-14.4zm16.8 18.5h-19.3l9.7-7.5 9.6 7.5zm.2 2.9-9.8 6-9.8-6h19.6zm2.3 15.5h-24.3l12.1-7.4 12.2 7.4zm-1.2-19.7-9.5-7.3 7.5-5.8 2 13.1zm-2.8-18.8-7-7.3 5.1-5.4 1.9 12.7zm-3.3-13.8-4.9 5.2-4.9-5.2h9.8zm-11.2 1.2 5.1 5.3-6.9 7.3 1.8-12.6zm-2.7 18.2 7.5 5.8-9.5 7.3 2-13.1zm-2.7 18.4 10 6.1-12 7.3 2-13.4zm-5.7 38.6 3-20.1 12.9 9-15.9 11.1zM308 377h25.5l-12.7 8.9L308 377zm14.3 10 12.9-9 3 20.1-15.9-11.1zM761.8 396.3l-.2-1.4-1-7.4-.2-1.4-1-7.4-.2-1.4-1.6-11.8h-7.5l-1.6 11.8-.2 1.4-1 7.4-.2 1.4-1 7.4-.2 1.4-1.6 11.6 1.9-1 7.6-5.3 7.6 5.3 1.9 1-1.5-11.6zm-2.4-8.3.9 6.3-5.7-3.5 4.8-2.8zm-2-9.2-3.5 2.7-3.5-2.7h7zm-7-1.4 3.4-3.6 3.4 3.6h-6.8zm8 8.7h-9.2l4.6-3.6 4.6 3.6zm.1 1.4-4.7 2.8-4.7-2.8h9.4zm1.1 7.4h-11.5l5.8-3.5 5.7 3.5zm-.5-9.4-4.5-3.5 3.6-2.8.9 6.3zm-1.4-8.9-3.3-3.5 2.4-2.5.9 6zm-1.5-6.5-2.3 2.5-2.3-2.5h4.6zm-5.4.5 2.4 2.5-3.3 3.5.9-6zm-1.2 8.7 3.6 2.8-4.5 3.5.9-6.3zm-1.3 8.7 4.7 2.9-5.7 3.5 1-6.4zm-2.7 18.3 1.4-9.5 6.1 4.3-7.5 5.2zm2.2-10h12.1l-6 4.2-6.1-4.2zm6.8 4.8 6.1-4.3 1.4 9.5-7.5-5.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M756.2 357.8v2.1h-.9v51.4h-2.9v-51.4h-.9v-2.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m763.1 397.7-.2-1.6-1.2-8.6-.2-1.6-1.2-8.6-.2-1.6-1.9-13.8h-8.8l-1.9 13.8-.2 1.6-1.2 8.6-.2 1.6-1.2 8.6-.2 1.6-1.8 13.6 2.3-1.2 8.9-6.2 8.9 6.2 2.3 1.2-2-13.6zm-2.7-9.8 1.1 7.4-6.7-4 5.6-3.4zm-2.4-10.8-4.1 3.2-4.1-3.2h8.2zm-8.1-1.6 4-4.2 4 4.2h-8zm9.3 10.3h-10.8l5.4-4.2 5.4 4.2zm.1 1.6-5.5 3.3-5.5-3.3h11zm1.3 8.6h-13.5l6.7-4.1 6.8 4.1zm-.7-11-5.3-4.1 4.2-3.2 1.1 7.3zm-1.5-10.4-3.9-4.1 2.8-3 1.1 7.1zm-1.8-7.7-2.7 2.9-2.7-2.9h5.4zm-6.3.7 2.8 3-3.8 4.1 1-7.1zm-1.5 10.1 4.2 3.2-5.3 4.1 1.1-7.3zm-1.5 10.2 5.6 3.4-6.7 4 1.1-7.4zm-3.2 21.5 1.6-11.2 7.2 5-8.8 6.2zm2.7-11.7H761l-7.1 4.9-7.1-4.9zm7.9 5.5 7.2-5 1.6 11.2-8.8-6.2zM60.2 404.5l-.1-1-.7-5-.1-1-.7-5-.1-1-1.1-8.1h-5.2l-1.1 8.1-.1 1-.7 5-.1 1-.7 5-.1 1-1.1 8 1.3-.7 5.2-3.6 5.2 3.6 1.3.7-1.1-8zm-1.6-5.7.6 4.3-3.9-2.4 3.3-1.9zm-1.4-6.3-2.4 1.9-2.4-1.9h4.8zm-4.7-1 2.3-2.5 2.3 2.5h-4.6zm5.5 6h-6.3l3.1-2.4 3.2 2.4zm0 1-3.2 1.9-3.2-1.9H58zm.8 5h-7.9l3.9-2.4 4 2.4zm-.4-6.4-3.1-2.4 2.5-1.9.6 4.3zm-.9-6.1-2.3-2.4 1.7-1.7.6 4.1zm-1.1-4.5-1.6 1.7-1.6-1.7h3.2zm-3.7.4 1.6 1.7L52 391l.7-4.1zm-.8 5.9 2.5 1.9-3.1 2.4.6-4.3zm-.9 6 3.3 2-3.9 2.4.6-4.4zm-1.9 12.6 1-6.5 4.2 2.9-5.2 3.6zm1.6-6.9H59l-4.1 2.9-4.2-2.9zm4.6 3.3 4.2-2.9 1 6.5-5.2-3.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 378.1v1.4h-.6v35.3h-2v-35.3h-.6v-1.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m61.2 405.4-.2-1.1-.8-5.9-.2-1.1-.8-5.9-.2-1.1-1.3-9.5h-6.1l-1.3 9.5-.2 1.1-.8 5.9-.2 1.1-.8 5.9-.2 1.1-1.3 9.3 1.5-.8 6.1-4.3 6.1 4.3 1.5.8-.8-9.3zm-1.9-6.6.8 5.1-4.6-2.8 3.8-2.3zm-1.7-7.4-2.8 2.2-2.8-2.2h5.6zm-5.5-1.2 2.7-2.9 2.7 2.9h-5.4zm6.4 7.1h-7.4l3.7-2.9 3.7 2.9zm.1 1.1-3.8 2.3-3.8-2.3h7.6zm.8 5.9h-9.3l4.6-2.8 4.7 2.8zm-.4-7.5-3.6-2.8 2.9-2.2.7 5zm-1.1-7.2-2.7-2.8 1.9-2 .8 4.8zm-1.2-5.2-1.9 2-1.9-2h3.8zm-4.3.4 1.9 2-2.6 2.8.7-4.8zm-1 6.9 2.9 2.2-3.6 2.8.7-5zm-1.1 7.1 3.8 2.3-4.6 2.8.8-5.1zm-2.1 14.7 1.1-7.7 4.9 3.4-6 4.3zm1.7-8.1h9.7l-4.9 3.4-4.8-3.4zm5.5 3.9 4.9-3.4 1.1 7.7-6-4.3zM549.7 395.7l-.1-.7-.5-3.5-.1-.7-.5-3.5-.1-.7-.8-5.6h-3.5l-.8 5.6-.1.7-.5 3.5-.1.7-.5 3.5-.1.7-.7 5.5.9-.5 3.6-2.5 3.6 2.5.9.5-.6-5.5zm-1.1-3.9.4 3-2.7-1.6 2.3-1.4zm-1-4.4-1.6 1.3-1.6-1.3h3.2zm-3.2-.6 1.6-1.7 1.6 1.7h-3.2zm3.8 4.1h-4.3l2.2-1.7 2.1 1.7zm0 .6-2.2 1.3-2.2-1.3h4.4zm.5 3.5h-5.4l2.7-1.6 2.7 1.6zm-.2-4.4-2.1-1.6 1.7-1.3.4 2.9zm-.7-4.2-1.6-1.6 1.1-1.2.5 2.8zm-.7-3.1-1.1 1.2-1.1-1.2h2.2zm-2.5.3 1.1 1.2-1.5 1.6.4-2.8zm-.6 4.1 1.7 1.3-2.1 1.6.4-2.9zm-.6 4.1 2.2 1.4-2.7 1.6.5-3zm-1.3 8.6.7-4.5 2.9 2-3.6 2.5zm1.1-4.7h5.7l-2.8 2-2.9-2zm3.2 2.2 2.9-2 .7 4.5-3.6-2.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M547.1 377.6v.9h-.4v24.2h-1.4v-24.2h-.4v-.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m550.4 396.3-.1-.8-.5-4.1-.1-.8-.5-4.1-.1-.8-.9-6.5H544l-.9 6.5-.1.8-.5 4.1-.1.8-.5 4.1-.1.8-.9 6.4 1.1-.6 4.2-2.9 4.2 2.9 1.1.6-1.1-6.4zm-1.3-4.6.5 3.5-3.1-1.9 2.6-1.6zm-1.2-5.1-1.9 1.5-1.9-1.5h3.8zm-3.8-.7 1.9-2 1.9 2h-3.8zm4.4 4.8h-5.1l2.5-2 2.6 2zm.1.8L546 393l-2.6-1.6h5.2zm.6 4h-6.4l3.2-1.9 3.2 1.9zm-.3-5.1-2.5-1.9 2-1.5.5 3.4zm-.8-4.9-1.8-1.9 1.3-1.4.5 3.3zm-.8-3.7-1.3 1.4-1.3-1.4h2.6zm-3 .4 1.3 1.4-1.8 1.9.5-3.3zm-.7 4.7 2 1.5-2.5 1.9.5-3.4zm-.7 4.8 2.6 1.6-3.1 1.9.5-3.5zm-1.5 10.1.8-5.3 3.4 2.4-4.2 2.9zm1.3-5.5h6.7l-3.3 2.3-3.4-2.3zm3.7 2.6 3.4-2.4.8 5.3-4.2-2.9zM502.8 394.2l-.1-.4-.3-2.2-.1-.4-.3-2.2-.1-.4-.5-3.5h-2.2l-.5 3.5-.1.4-.3 2.2-.1.4-.3 2.2-.1.4-.5 3.4.6-.3 2.2-1.6 2.2 1.6.6.3-.1-3.4zm-.7-2.4.3 1.9-1.7-1 1.4-.9zm-.6-2.7-1 .8-1-.8h2zm-2-.4 1-1 1 1h-2zm2.3 2.5h-2.7l1.3-1 1.4 1zm.1.4-1.4.8-1.4-.8h2.8zm.3 2.2h-3.4l1.7-1 1.7 1zm-.2-2.7-1.3-1 1-.8.3 1.8zm-.4-2.6-1-1 .7-.7.3 1.7zm-.4-2-.7.7-.7-.7h1.4zm-1.6.2.7.7-1 1 .3-1.7zm-.4 2.5 1 .8-1.3 1 .3-1.8zm-.3 2.6 1.4.8-1.7 1 .3-1.8zm-.8 5.3.4-2.8 1.8 1.2-2.2 1.6zm.6-2.9h3.5l-1.8 1.2-1.7-1.2zm2 1.4 1.8-1.2.4 2.8-2.2-1.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.2 383v.5h-.3v15.1h-.8v-15.1h-.3v-.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m503.2 394.6-.1-.5-.3-2.5-.1-.5-.3-2.5-.1-.5-.5-4h-2.6l-.5 4-.1.5-.3 2.5-.1.5-.3 2.5-.1.5-.5 4 .7-.3 2.6-1.8 2.6 1.8.7.3-.7-4zm-.8-2.8.3 2.2-1.9-1.2 1.6-1zm-.7-3.2-1.2.9-1.2-.9h2.4zm-2.4-.5 1.2-1.2 1.2 1.2h-2.4zm2.8 3H499l1.6-1.2 1.5 1.2zm0 .5-1.6 1-1.6-1h3.2zm.4 2.5h-3.9l2-1.2 1.9 1.2zm-.2-3.2-1.5-1.2 1.2-.9.3 2.1zm-.5-3-1.1-1.2.8-.9.3 2.1zm-.5-2.3-.8.8-.8-.8h1.6zm-1.8.2.8.9-1.1 1.2.3-2.1zm-.5 3 1.2.9-1.5 1.2.3-2.1zm-.4 3 1.6 1-1.9 1.2.3-2.2zm-.9 6.2.5-3.3 2.1 1.5-2.6 1.8zm.7-3.4h4.1l-2.1 1.4-2-1.4zm2.4 1.6 2.1-1.5.5 3.3-2.6-1.8zM192.4 400l-.1-.4-.3-2.2v-.4l-.3-2.2-.1-.4-.5-3.5H189l-.5 3.5-.1.4-.3 2.2-.1.4-.3 2.2-.1.4-.5 3.4.6-.3 2.2-1.6 2.2 1.6.6.3-.3-3.4zm-.7-2.5.3 1.9-1.7-1 1.4-.9zm-.6-2.7-1 .8-1-.8h2zm-2-.4 1-1 1 1h-2zm2.3 2.6h-2.7l1.3-1 1.4 1zm.1.4-1.4.8-1.4-.8h2.8zm.3 2.1h-3.4l1.7-1 1.7 1zm-.2-2.7-1.3-1 1-.8.3 1.8zm-.4-2.6-1-1 .7-.7.3 1.7zm-.4-1.9-.7.7-.7-.7h1.4zm-1.6.2.7.7-1 1 .3-1.7zm-.3 2.5 1 .8-1.3 1 .3-1.8zm-.4 2.5 1.4.8-1.7 1 .3-1.8zm-.8 5.4.4-2.8 1.8 1.2-2.2 1.6zm.6-2.9h3.5l-1.8 1.2-1.7-1.2zm2 1.3 1.8-1.2.4 2.8-2.2-1.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.8 388.7v.6h-.3v15h-.8v-15h-.3v-.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m192.8 400.4-.1-.5-.3-2.5-.1-.5-.3-2.5-.1-.5-.5-4h-2.6l-.5 4-.1.5-.3 2.5-.1.5-.3 2.5-.1.5-.5 4 .7-.3 2.6-1.8 2.6 1.8.7.3-.7-4zm-.8-2.9.3 2.2-1.9-1.2 1.6-1zm-.7-3.2-1.2.9-1.2-.9h2.4zm-2.4-.4 1.2-1.2 1.2 1.2h-2.4zm2.8 3h-3.1l1.6-1.2 1.5 1.2zm0 .5-1.6 1-1.6-1h3.2zm.4 2.5h-3.9l2-1.2 1.9 1.2zm-.2-3.2-1.5-1.2 1.2-.9.3 2.1zm-.5-3.1-1.1-1.2.8-.9.3 2.1zm-.5-2.2-.8.8-.8-.8h1.6zm-1.8.2.8.9-1.1 1.2.3-2.1zm-.5 2.9 1.2.9-1.5 1.2.3-2.1zm-.4 3 1.6 1-1.9 1.2.3-2.2zm-.9 6.3.5-3.3 2.1 1.5-2.6 1.8zm.7-3.4h4.1l-2.1 1.4-2-1.4zm2.4 1.6 2.1-1.5.5 3.3-2.6-1.8zM816.6 411l-.1-.7-.5-3.5-.1-.7-.5-3.5-.1-.7-.8-5.6H811l-.8 5.6-.1.7-.5 3.5-.1.7-.5 3.5-.1.7-.7 5.5.9-.5 3.6-2.5 3.6 2.5.9.5-.6-5.5zm-1.1-3.9.4 3-2.7-1.6 2.3-1.4zm-1-4.4-1.6 1.3-1.6-1.3h3.2zm-3.2-.6 1.6-1.7 1.6 1.7h-3.2zm3.7 4.1h-4.3l2.2-1.7 2.1 1.7zm.1.7-2.2 1.3-2.2-1.3h4.4zm.5 3.4h-5.4l2.7-1.6 2.7 1.6zm-.3-4.4-2.1-1.6 1.7-1.3.4 2.9zm-.6-4.2-1.6-1.6 1.1-1.2.5 2.8zm-.7-3.1-1.1 1.2-1.1-1.2h2.2zm-2.5.3 1.1 1.2-1.5 1.6.4-2.8zm-.6 4.1 1.7 1.3-2.1 1.6.4-2.9zm-.6 4.1 2.2 1.4-2.7 1.6.5-3zm-1.3 8.6.7-4.5 2.9 2-3.6 2.5zm1-4.7h5.7l-2.8 2-2.9-2zm3.2 2.2 2.9-2 .7 4.5-3.6-2.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M814 392.9v.9h-.4V418h-1.4v-24.2h-.4v-.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m817.3 411.6-.1-.8-.5-4.1-.1-.8-.5-4.1-.1-.8-.9-6.5h-4.2l-.9 6.5-.1.8-.5 4.1-.1.8-.5 4.1-.1.8-.9 6.4 1.1-.6 4.2-2.9 4.2 2.9 1.1.6-1.1-6.4zm-1.4-4.6.5 3.5-3.1-1.9 2.6-1.6zm-1.1-5-1.9 1.5-1.9-1.5h3.8zm-3.8-.8 1.9-2 1.9 2H811zm4.4 4.8h-5.1l2.5-2 2.6 2zm0 .8-2.6 1.6-2.6-1.6h5.2zm.6 4h-6.4l3.2-1.9 3.2 1.9zm-.3-5.1-2.5-1.9 2-1.5.5 3.4zm-.7-4.9-1.8-1.9 1.3-1.4.5 3.3zm-.9-3.6-1.3 1.4-1.3-1.4h2.6zm-2.9.3 1.3 1.4-1.8 1.9.5-3.3zm-.7 4.7 2 1.5-2.5 1.9.5-3.4zm-.7 4.8 2.6 1.6-3.1 1.9.5-3.5zm-1.5 10.1.8-5.3 3.4 2.4-4.2 2.9zm1.2-5.5h6.7l-3.3 2.3-3.4-2.3zm3.8 2.6 3.4-2.4.8 5.3-4.2-2.9z"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6,
    cy: 104.4,
    r: 1.3,
    className: "st1"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 737.2,
    cy: 110.5,
    r: 0.6,
    className: "st1"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 638.4,
    cy: 104.9,
    r: 1.3,
    className: "st1"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 805.8,
    cy: 115,
    r: 1.3,
    className: "st1"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 114.5,
    r: 1.3,
    className: "st1"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.7,
    cy: 104.9,
    r: 1.3,
    className: "st1"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.4,
    cy: 130.8,
    r: 1.3,
    className: "st2"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 114.7,
    r: 0.6,
    className: "st2"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.6,
    cy: 135.9,
    r: 0.6,
    className: "st2"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.6,
    cy: 192.1,
    r: 0.6,
    className: "st2"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.1,
    cy: 117.1,
    r: 0.6,
    className: "st2"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.5,
    cy: 127,
    r: 0.6,
    className: "st2"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.6,
    cy: 150.8,
    r: 0.6,
    className: "st2"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 165,
    r: 0.6,
    className: "st2"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 103.8,
    r: 0.6,
    className: "st2"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 170.3,
    r: 0.6,
    className: "st2"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6,
    cy: 103.2,
    r: 0.6,
    className: "st2"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 147.6,
    r: 0.6,
    className: "st2"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 206,
    r: 1.3,
    className: "st2"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4,
    cy: 111.4,
    r: 1.3,
    className: "st2"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.3,
    cy: 160,
    r: 1.3,
    className: "st2"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.2,
    cy: 196.5,
    r: 1.3,
    className: "st2"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.2,
    cy: 110.1,
    r: 1.3,
    className: "st2"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.3,
    cy: 128.3,
    r: 1.3,
    className: "st2"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.2,
    cy: 163.1,
    r: 1.3,
    className: "st2"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.1,
    cy: 148.9,
    r: 1.3,
    className: "st2"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.8,
    cy: 151,
    r: 1.3,
    className: "st2"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.5,
    cy: 134.8,
    r: 0.6,
    className: "st2"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.1,
    cy: 156,
    r: 0.6,
    className: "st2"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 747.1,
    cy: 212.2,
    r: 0.6,
    className: "st2"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.5,
    cy: 137.2,
    r: 0.6,
    className: "st2"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 810.9,
    cy: 147.1,
    r: 0.6,
    className: "st2"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 825.1,
    cy: 171,
    r: 0.6,
    className: "st2"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 828.9,
    cy: 185.1,
    r: 0.6,
    className: "st2"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.4,
    cy: 123.9,
    r: 0.6,
    className: "st2"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.9,
    cy: 190.4,
    r: 0.6,
    className: "st2"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 123.3,
    r: 0.6,
    className: "st2"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.9,
    cy: 167.7,
    r: 0.6,
    className: "st2"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.3,
    cy: 152.2,
    r: 0.6,
    className: "st2"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.2,
    cy: 206.6,
    r: 1.3,
    className: "st2"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 602.8,
    cy: 131.6,
    r: 1.3,
    className: "st2"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.7,
    cy: 180.1,
    r: 1.3,
    className: "st2"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.6,
    cy: 216.6,
    r: 1.3,
    className: "st2"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.6,
    cy: 130.3,
    r: 1.3,
    className: "st2"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.7,
    cy: 148.4,
    r: 1.3,
    className: "st2"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 768.6,
    cy: 183.2,
    r: 1.3,
    className: "st2"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.5,
    cy: 169,
    r: 1.3,
    className: "st2"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.7,
    cy: 140.9,
    r: 1.3,
    className: "st2"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.4,
    cy: 124.7,
    r: 0.6,
    className: "st2"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 421,
    cy: 145.9,
    r: 0.6,
    className: "st2"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 202.1,
    r: 0.6,
    className: "st2"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.4,
    cy: 127.1,
    r: 0.6,
    className: "st2"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.9,
    cy: 137.1,
    r: 0.6,
    className: "st2"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 502,
    cy: 160.9,
    r: 0.6,
    className: "st2"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.8,
    cy: 175.1,
    r: 0.6,
    className: "st2"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.3,
    cy: 113.9,
    r: 0.6,
    className: "st2"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.8,
    cy: 180.3,
    r: 0.6,
    className: "st2"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 327,
    cy: 113.2,
    r: 0.6,
    className: "st2"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.9,
    cy: 157.7,
    r: 0.6,
    className: "st2"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.8,
    cy: 216.1,
    r: 1.3,
    className: "st2"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.8,
    cy: 121.5,
    r: 1.3,
    className: "st2"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.7,
    cy: 170.1,
    r: 1.3,
    className: "st2"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.6,
    cy: 206.6,
    r: 1.3,
    className: "st2"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.5,
    cy: 120.2,
    r: 1.3,
    className: "st2"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.6,
    cy: 138.4,
    r: 1.3,
    className: "st2"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.6,
    cy: 173.2,
    r: 1.3,
    className: "st2"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 514.4,
    cy: 159,
    r: 1.3,
    className: "st2"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 229.4,
    r: 1.3,
    className: "st3"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.6,
    cy: 235.5,
    r: 0.6,
    className: "st3"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 635.8,
    cy: 229.9,
    r: 1.3,
    className: "st3"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.2,
    cy: 239.9,
    r: 1.3,
    className: "st3"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.6,
    cy: 225.5,
    r: 0.6,
    className: "st3"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.4,
    cy: 239.4,
    r: 1.3,
    className: "st3"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.2,
    cy: 229.9,
    r: 1.3,
    className: "st3"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.8,
    cy: 255.8,
    r: 1.3,
    className: "st3"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 239.6,
    r: 0.6,
    className: "st3"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.1,
    cy: 260.8,
    r: 0.6,
    className: "st3"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.5,
    cy: 242,
    r: 0.6,
    className: "st3"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 251.9,
    r: 0.6,
    className: "st3"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.1,
    cy: 275.8,
    r: 0.6,
    className: "st3"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.9,
    cy: 290,
    r: 0.6,
    className: "st3"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.4,
    cy: 228.8,
    r: 0.6,
    className: "st3"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1,
    cy: 228.1,
    r: 0.6,
    className: "st3"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 272.6,
    r: 0.6,
    className: "st3"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9,
    cy: 236.4,
    r: 1.3,
    className: "st3"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.8,
    cy: 285,
    r: 1.3,
    className: "st3"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.6,
    cy: 235.1,
    r: 1.3,
    className: "st3"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.7,
    cy: 253.2,
    r: 1.3,
    className: "st3"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.7,
    cy: 288,
    r: 1.3,
    className: "st3"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 273.9,
    r: 1.3,
    className: "st3"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 637.2,
    cy: 275.9,
    r: 1.3,
    className: "st3"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 675.9,
    cy: 259.7,
    r: 0.6,
    className: "st3"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.5,
    cy: 280.9,
    r: 0.6,
    className: "st3"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 797.9,
    cy: 262.1,
    r: 0.6,
    className: "st3"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 808.4,
    cy: 272,
    r: 0.6,
    className: "st3"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.8,
    cy: 248.9,
    r: 0.6,
    className: "st3"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 647.5,
    cy: 248.2,
    r: 0.6,
    className: "st3"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 630.4,
    cy: 292.7,
    r: 0.6,
    className: "st3"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 553.8,
    cy: 277.2,
    r: 0.6,
    className: "st3"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.3,
    cy: 256.5,
    r: 1.3,
    className: "st3"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.1,
    cy: 255.2,
    r: 1.3,
    className: "st3"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 737.1,
    cy: 273.3,
    r: 1.3,
    className: "st3"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 294,
    r: 1.3,
    className: "st3"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.2,
    cy: 265.9,
    r: 1.3,
    className: "st3"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.9,
    cy: 249.7,
    r: 0.6,
    className: "st3"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.5,
    cy: 270.9,
    r: 0.6,
    className: "st3"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.9,
    cy: 252.1,
    r: 0.6,
    className: "st3"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.4,
    cy: 262,
    r: 0.6,
    className: "st3"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.5,
    cy: 285.9,
    r: 0.6,
    className: "st3"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.8,
    cy: 238.9,
    r: 0.6,
    className: "st3"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.5,
    cy: 238.2,
    r: 0.6,
    className: "st3"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.4,
    cy: 282.7,
    r: 0.6,
    className: "st3"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.2,
    cy: 246.5,
    r: 1.3,
    className: "st3"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.1,
    cy: 295.1,
    r: 1.3,
    className: "st3"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 481,
    cy: 245.2,
    r: 1.3,
    className: "st3"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.1,
    cy: 263.3,
    r: 1.3,
    className: "st3"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.9,
    cy: 284,
    r: 1.3,
    className: "st3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m444.1 362.1-.6-4.8-3.4-24.9-.6-4.8-3.4-24.9-.6-4.8-5.4-39.9h-25.5l-5.4 39.9-.6 4.8-3.4 24.9-.6 4.8-3.4 24.9-.6 4.8-5.3 39.2 6.5-3.5 25.7-17.9 25.7 17.9 6.5 3.5-5.6-39.2zm-8-28.1 3.2 21.4-19.2-11.7 16-9.7zm-7-31.2-11.9 9.2-11.9-9.2h23.8zm-23.4-4.8 11.5-12.1 11.5 12.1h-23zm27.1 29.7h-31.1l15.5-12 15.6 12zm.3 4.8-15.8 9.6-15.8-9.6h31.6zm3.6 24.8h-39l19.5-11.9 19.5 11.9zm-1.8-31.7-15.2-11.8 12.1-9.4 3.1 21.2zm-4.5-30.1-11.2-11.7 8.2-8.6 3 20.3zm-5.3-22.1-7.9 8.3-7.9-8.3h15.8zm-18 1.9 8.1 8.5-11.1 11.7 3-20.2zm-4.3 29.2 12.1 9.4-15.2 11.8 3.1-21.2zm-4.4 29.5 16 9.8-19.2 11.7 3.2-21.5zm-9.1 62 4.8-32.2 20.7 14.5-25.5 17.7zm7.5-33.9h40.9l-20.4 14.3-20.5-14.3zm23 16.1 20.7-14.5 4.8 32.2-25.5-17.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M841.9 419.4v175.9H0V419.4s19.3-3 58.5-6.8c6.6-.6 13.8-1.3 21.5-2 10.2-.9 21.5-1.8 33.7-2.7 10-.7 20.7-1.5 32-2.2 5.5-.3 11.1-.7 16.8-1 9.3-.5 18.9-1 29-1.5 8.6-.4 17.5-.8 26.8-1.2 7.8-.3 15.9-.6 24.2-1 11.9-.4 24.3-.8 37.2-1.2 8.9-.2 18-.5 27.3-.7 8.9-.2 18.1-.4 27.4-.5 27.1-.4 56-.7 86.5-.7 19.6 0 38.4.1 56.4.3 3.2 0 6.5.1 9.6.1 3.6 0 7.2.1 10.7.1 8.1.1 16.1.2 23.8.4 15.6.3 30.5.6 44.8 1 11.4.3 22.3.6 32.9 1 7.5.3 14.8.5 21.9.8 14.9.6 29 1.2 42.3 1.9 32.3 1.7 59.9 3.5 83.1 5.4 65.7 5.3 95.5 10.5 95.5 10.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M438.4 219c-.3.1-.6.2-1.1.4.3 1.1.7 2.2 1 3.3-.1-.2-.3-.4-.4-.5-.4.2-.8.5-1.2.7.7 1.2 1.4 2.5 2.2 3.8-.2-1.5-.5-2.7-.7-4 .7 2.8 1.6 5.5 2.2 8.3 2 9 3.1 18.2 3.3 27.4 0 .3.1.6 0 .8-.2.3-.6.8-.8.7-.3 0-.9-.4-1-.7-.2-.5-.1-1.1 0-1.6.1-8.5-.5-17-1.8-25.4 0-.1-.1-.1-.2-.3v2.2c.1 1-.2 1.6-1.3 1.6.2 1.3.3 2.6.5 3.9.2 1.5-.1 1.9-1.6 1.9-.1 2.9.5 5.7 1.1 8.5.2 1 1 2.1-.7 2.7-.1 0-.1.5-.1.8v4c0 .7-.2 1.3-1 1.3s-1-.6-1-1.4c.1-3 .4-5.9.3-8.9-.1-2.5-.4-5-.9-7.4-.9-5.2-1.9-10.4-3-15.6-.2-.8-.6-1.6-.8-2.2-.8.3-1.5.7-2.2.8-1 .1-1.8.4-2.2 1.3.1-.3.2-.6.2-.9-3.4.5-5 1.9-5.6 4.8 1.3-1 2.7-2 4.2-3.1.4-.3.8-.6 1.2-.8.2 0 .5.1.7.1.6 0 1.2-.2 1.8-.2 1.2 0 1.8.6 1.6 1.3-.3 1.1-1 .9-1.8.7-1.6-.4-3 .3-4.3 1-1.4.7-2.6 1.8-3.8 2.7-.2.1-.4.3-.4.5-.7 2.4-1.6 4.7-1.5 7.3.1 2.5 0 5 .2 7.5-.1-2.4-.2-4.8-.3-7.3h-.4c-.1 2.1-.3 4.1-.2 6.2.1 5.2.4 10.4.6 15.5.3 4.8.6 9.5.9 14.3.1 1.6.1 3.1.1 4.7-1-9.8-1.9-19.5-2.9-29.6v5.8c-.2-1.7-.3-3.5-.5-5.2h-.3c-.1.3-.1.6-.1.6-.5-4-1-8.3-1.5-12.5h-.3c-.1.5-.1.9-.2 1.4h-.1c0-1.1.1-2.1 0-3.2-.2-1.1-.5-2.1-.9-3.2-.3-1.1-.7-2.1-1.2-3.1-.3-.9-1.8-1.4-3.2-1.1-2 .5-3.9 1.4-5.3 2.9-1.5 1.5-2.9 3.2-4 5-.6 1-.6 2.5-.8 3.8-.2 1-.3 2.1-.4 3.1-.1.7-.5 1.2-1.2 1-.7-.2-.9-.8-.7-1.5.1-.3.1-.6.2-1-.3-.2-.6-.4-1.1-.7-.1 2.4-.2 4.7-.3 7 0 .8.1 1.7-.1 2.5-.1.4-.6.8-1 1.2-.3-.4-.9-.7-.9-1.1 0-1.7 0-3.4.2-5.1.5-6.6 1.7-13.2 3.8-19.5-1.4-.1-1.8-.7-1.3-2 1.3-3.2 2.6-6.5 3.9-9.7-1.4-.4-1.6-.9-.9-2.3 1.3-2.4 2.8-4.7 5.2-6.1-.4-.3-1.1-.4-1.3-.8-.2-.4.1-.9.2-1.7-.6.5-1.1.8-1.4 1.3-2.2 2.9-3.1 6.2-3.7 9.7l-.3 1.8c-.1.7-.4 1.5-1.3 1.2-.9-.2-.9-.9-.6-1.7.8-1.8 1.5-3.7 2.3-5.6-.4-.2-.8-.3-1.4-.6-.3.9-.6 1.9-.8 2.8-1.8 9.3-3.5 18.6-5.2 27.9-.3 1.4-.4 2.9-.6 4.3-.1.8-.3 1.5-1.2 1.3-.9-.1-1-.9-.8-1.6 1.6-7.9 3.2-15.9 4.8-23.8.1-.3.1-.5-.1-.8-.3 1.1-.5 2.2-.8 3.3-.1.5-.5.9-.9 1.2-.1.1-.8-.1-.9-.3-.1-.5-.2-1.1 0-1.6.6-1.4 1.2-2.8 2.1-4 1.7-2.3 2.1-5 2.8-7.6 0-.2.1-.5 0-.5-1-1-.2-1.8.3-2.7 1.3-2.5 2.5-5.1 3.8-7.7-.1-.1-.2-.2-.2-.3-.5.3-1.1.6-1.6 1-1.9 1.6-2.7 3.8-3.3 6.1-.2.9-.3 1.8-.5 2.7-.1.6-.6 1.2-1.2.9-.4-.2-.8-.9-.7-1.3.8-2.8 1.7-5.5 3.9-7.6 1-1 2.4-1.7 3.7-2.6-.3-.7.3-1.3 1-1.8 1-.6 1.9-1.3 2.9-1.9 1.5-.9 3.2-.8 4.8-.9 1-.1 2.1.1 3.1-.1-1.9-1.9-4-3-6.7-2.3-.4.1-.8.2-1 .4-3.1 2.3-6.2 4.7-8 8.3-.1.1-.1.2-.2.3-.5.2-1.1.6-1.4.5-.7-.2-.7-1-.3-1.6.8-1.1 1.6-2.2 2.4-3.2 2-2.5 4.4-4.7 7.4-5.9 1.2-.5 2.5-.7 3.8-.9 1.2-.2 2.3-.3 3.5-.3 1.5 0 3 0 4.4.5.9.3 1.5 1.5 2.1 2.4.5.8.6 1.8 1.1 2.7.3-1.5.6-3 1-4.5 1.2-4.3 3-8.3 6.7-11.2.8-.6 1.8-1.1 2.8-1.6.6-.3 1.3-.4 1.6.4.3.7 0 1.3-.8 1.6-3 1.3-4.7 2.7-5.9 4.7.5.3 1.3.4 1.5.8.5.8-.3 1.2-.8 1.6-3.3 2.4-5 5.6-5.1 9.7.7-1.7 1.2-3.5 2-5.1.7-1.4 1.8-2.6 2.8-3.7.5-.6 1.3-.9 1.8 0 .5.8 0 1.3-.7 1.7-2 1.2-4.1 3.8-4.8 6.3.4-.2.7-.5 1-.6 1.8-.7 3.6-1.4 5.5-2 .7-.2 1.3.2 1.2.8 0 .4-.4 1-.9 1.3-.9.5-2 .9-3 1.4.2.8.3 1.4.5 2.1l3.6-1.8v-.2c-.9.1-1.7.1-2.8.2 1.9-1.3 3.8-1.8 5.8-2.1.7-.1 1.1.5 1 1.1-.2.9-.6 1.7-.9 2.6 1.9.2 2.1.4 1.9 1.8 1.2.4 2.4.8 3.7 1.1-.9-1.9-2.3-3.2-4.6-3.8 2.3 0 3.9.7 5.4 1.9.9.8 2.2 1.3 1.8 2.9 0 .1.3.4.5.6.8 1 1.7 2.1 2.5 3.1.4.6.4 1.3-.4 1.7-.8.4-1.2-.2-1.4-.9-.7-2.1-1.8-3.9-3.9-5.1.5 1.4 2.5 1.9 1.6 3.7 4.1 3.5 5.5 8.4 6.6 13.4.1.7.1 1.4-.8 1.5-.9.1-1.1-.5-1.2-1.2-.1-.4-.2-.9-.2-1.2-.5.2-1 .8-1.4.7-.4-.1-.7-.8-.9-1.3-.6-1.6-1.1-3.2-2.4-4.4-1-.9-1.8-2-2.7-2.9-.4-.4-1-.5-1.6-.7.2 1.1.4 1.8 1.6 1.9.4 0 .8.7 1 1.2.7 1.1 1.3 2.3 1.8 3.5.2.9.1 1.5.1 2zm-6.9 1.1c-1.8-.5-3.1-.3-3.5.7h3.2c.1-.1.2-.5.3-.7 1.1 1.5 3.1.9 4.4 2-1.2-1.3-2.6-2.1-4.4-2zm-22.1-3.8c.2-.1.5-.1.8-.2-.9-1.1-2-.8-3-.6-1.5.3-2.8 1-3.4 2.7.8-.7 1.5-1.3 2.2-1.7 1.1-.6 2.3-1 3.4-.2-1.6-.2-2.4.2-3.2 1.4.9-.1 1.9-.2 3-.3.1-.3.1-.7.2-1.1zm0-18.9c-1 .2-2.1.2-2.9.6-.8.4-1.5.6-2.2-.2-.9.8-1.8 1.6-2.7 2.3.1.1.1.2.2.2.8-.3 1.7-.8 2.5-.9.8-.1 1.7 0 2.7 0-1.2.4-2.1.7-3.1.9 0 .1.1.2.1.3.9-.1 1.9-.4 2.8-.4 1 0 2 .2 3 .3.2 0 .4-.2.7-.3-.8-.4-1.6-.4-2.3-.7-.4-.2-.7-.9-.7-1.3 0-.3.7-.6 1.2-.7.4-.1.8.1 1.3.1 1.8.8 3 2.8 5.3 2.9-.8-1.9-2.4-2.5-4.1-3-.6 0-1.2 0-1.8-.1zm23.5 24.8c-1.6-1.4-4.9-1.7-6-.4.1.4.3.7.5 1.1.6-.2 1.1-.4 1.6-.6 1.4-.5 2.4-.2 3.2 1.1.3.5.5 1 .7 1.6l1.2 4.2c.7 2.5 1.3 5 1.9 7.6-.1-2.2-.2-4.5-.7-6.6-.6-2.6-1.4-5-2.2-7.6.6 1.5 1.3 2.9 1.9 4.4l.6 1.2c.6 1.1 1.3 2.2 1.9 3.4.2.4.3.9.6 1.6.3-2.9-.1-6-1-7.9-.7-1.6-1.9-2.7-3.6-3.4-.5-.2-.9-.4-.6.3zm-37.1 18.6c.1 0 .1 0 .2.1.9-2.3 1.9-4.6 2.9-7.2.1.5.2.7.3.9.6-.7 1.5-1.3 1.5-1.9 0-1.3.7-2.1 1.2-3.1.1-.3.1-.7.1-1.1h-.3c-.7.9-1.4 1.7-2.1 2.6-.6.8-1.1 1.4-2.3.6-.5 3.1-1 6.1-1.5 9.1zm1.9-11.2c.1.1.3.1.4.2.8-1.2 2.7-1.5 2.5-3.5 0-.2.1-.4.2-.6.3-.6.7-1.1.1-1.8-.2-.2 0-1 .2-1.3.8-1.3 1.7-2.5 2.5-3.8-.6 0-1.1-.1-1.9-.1-1.3 3.4-2.6 7.2-4 10.9zm14.5-37.1c1.7 1.9 3.5 3.9 5.3 5.8.6-3.8-2.2-6.7-5.3-5.8zm24.2 13.3c-1.4-3.2-5-4.6-7.1-3.1.9.1 2.1.1 3.3.4.4.1 1 .8 1 1-.4 1.4.5 1.3 1.3 1.4.4 0 .9.2 1.5.3zm-28.5 23c.3-.7.5-1.2.7-1.7-2-.2-3.5.9-3.8 2.9 1.1-.5 2.1-.9 3.1-1.2zm9.4-24.8c.3-2.5-1.8-6.6-4-7.6 2.6 1.9 2.8 5 4 7.6zm15.5 10.3c-1.8-1.5-4.7-1.5-5.9-.1 1.7.1 3.7-.9 5.2.9.2-.2.4-.5.7-.8zm1.6 2.3c-1.9.5-3.7.9-5.5 1.4 2.2-.1 4.4-.9 6.4 1.2-.4-1-.7-1.9-.9-2.6zm-31.4 8.7c1.7-1 3.1-2.8 2.7-3.5-1.8.4-2.2 1.9-2.7 3.5zm32.6 3.6c.5 2.5 1 5.1 1.4 7.6 0-2.6-.1-5.2-1.4-7.6zm5.2-16.5-.1.1c0 .8-.1 1.7.1 2.5.3 1 1 1.9 1.5 2.8.1 0 .2-.1.3-.1-.6-1.8-1.2-3.5-1.8-5.3zm-14.7-7c1.4-.3 2.8-.6 4.1-.8 0-.1-.1-.2-.1-.3-1.5-.6-2.7.2-4 1.1zm9.2 4.6c.6.3 1.3.7 2 1l.2-.2c-.5-.9-.9-1.8-1.5-2.8-.3.9-.5 1.4-.7 2zm-13.2-7.8-2.7 2.7c1.3.1 2.4-1 2.7-2.7zm-13.8 21.1c1.2.3 2.2.6 3.5 1-1.3-1.7-2.2-1.9-3.5-1zm19.9-16.5c.9-.4 1.7-.7 2.4-1 0-.1 0-.2-.1-.3-.8-.1-1.6-.1-2.5-.2.1.6.1 1 .2 1.5zm-24.9-3.9c0 .1.1.2.1.3 1-.3 2-.6 3.1-.9 0 0 .1-.3.2-.8-1.3.6-2.3 1-3.4 1.4zm26.4 7c-1.6.3-3.1 1.2-3.8 2.5 1.4-.9 2.5-1.7 3.8-2.5zm-1.9 10c1-.3 1.8-.5 2.7-.7-1.5-.9-2-.8-2.7.7zm-1.9-4.7c1.2 1.2 1.8 1.2 2.6.1-.9 0-1.6 0-2.6-.1zm-15.8-7.8c.1-.1.1-.2.2-.3-.9-.8-1.7-1.9-3.1-1.6 1 .6 1.9 1.3 2.9 1.9zm.5-4.5-.3.3 2.1 2.1c.1-.1.2-.2.2-.3-.5-.8-.9-1.8-2-2.1zm-9.3 9.8c.1 0 .1.1.2.1.6-.8 1.2-1.6 1.9-2.4-.3-.1-.5-.2-.8-.4-.5 1-.9 1.8-1.3 2.7zm-2.2-9.2c-.3.7-.5 1.4-.8 2.1.1 0 .1.1.2.1l1.5-1.2c-.3-.3-.6-.7-.9-1zm.6 17.2c.7-1 1.5-2 1.8-3.3-.1-.1-.3-.1-.4-.2-.5 1.2-.9 2.4-1.4 3.5zm8.6-11.8c-.8-.9-1.4-.9-2.5.3.8-.1 1.7-.2 2.5-.3zm21.8-1.4c1.1-.9 1.9.1 2.9.4-.8-1.4-1.4-1.5-2.9-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2 189.5c-2.5 1.9-4.3 4-5.5 6.6-1.5 3.1-2.8 6.4-4.2 9.6-.2.4-.2.8-.5 1-.3.3-.9.6-1.2.5-.3-.1-.5-.7-.7-1.1 0-.1 0-.2.1-.3 2.1-4.3 3.7-9 6.7-12.8 3.4-4.3 7.8-6.8 13.1-7.9 1.5-.3 2.8-.3 4.1.1 1.3.4 2.1 1.1 2.4 2.6.1.6.8 1.1 1.3 1.6.2.3.5.5.6.9-.6-.5-1.2-1-1.8-1.6-.1.4-.2.6-.2.6-.9-2.1-2.9-2.2-4.9-2.6-1.9-.4-3.7 0-5.5.6-1.5.5-2.5 1.5-3.3 2.7-4.2 6-6.9 12.6-8.3 19.7-1.1 5.3-1.6 10.6-2.4 15.9-.1.8.1 1.9-1.1 1.8-1.3-.1-.9-1.2-.8-2 .5-3.3.9-6.5 1.6-9.8 1.4-7.2 3.5-14.1 7.1-20.4.9-1.9 2.1-3.6 3.4-5.7zM382 252c-.1 1.5-.2 3-.2 4.4-.1 7.1-.3 14.2-.4 21.3 0 4 .2 8.1.4 12.1 0 .4-.1.9-.3 1.2-.2.2-.8.4-1 .3-.3-.2-.7-.7-.7-1-.1-1.1 0-2.1 0-3.2.1-5.6.1-11.2.4-16.8.3-6.1 1-12.1 1.5-18.2.1-.1.2-.1.3-.1zM454.7 257.5c.6 4.6 1.3 9.2 1.8 13.9.6 5.4.9 10.9 1.4 16.3v1.5c0 .7-.2 1.3-1 1.3s-1-.6-1-1.3c0-.6.1-1.1.1-1.7.2-9.5-.5-19-1.3-28.4 0-.5-.1-1-.2-1.4 0-.2.1-.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.6 190.5c-1-2.2-1.8-4.6-3-6.8-1-1.8-2.2-3.5-3.4-5.2-2-2.6-4-2.6-6.3-.3-1 1.1-1.9 2.4-2.8 3.7-.4.5-.9 1.1-1.6.6-.7-.5-.5-1.2 0-1.8 1.1-1.3 2.2-2.7 3.4-3.9 2.8-2.6 5.8-2.3 8 .8 2.7 3.8 4.6 7.9 5.7 12.5v.4zM392.8 258.4v18.2c0 4.1-.1 8.1-.2 12.2 0 .7-.1 1.5-1.1 1.4-.9-.1-.9-.8-.9-1.5.5-7.2 1.1-14.5 1.6-21.7.3-2.8.4-5.7.6-8.6zM370.9 313.6c0 3.8-.1 7.5 0 11.3.1 4.8.4 9.5.5 14.3v.2c0 .7 0 1.5-1 1.5-.9 0-1.1-.7-1-1.4.1-3.3.2-6.5.3-9.8.2-5.4.5-10.7.8-16.1h.4zM401.6 244.1c-.2 1.2-.4 2.4-.5 3.6h.2c.7-1.9 1.3-3.8 2-5.8h.1l-.9 6.9c-.1.9-.2 1.8-.3 2.8-.1 1-.3 1.7-1.6 1.5v4.6c0 .8 0 1.6-1 1.6s-1-.8-1-1.6c.1-1.1.2-2.3.4-3.4l2.1-10.2c.2-.1.4 0 .5 0zM448.4 215.8c1.6 2.4 2.4 5.2 2.6 8.1.3 3.1.4 6.3.6 9.4 0 .8-.1 1.4-1 1.4-.8 0-1-.6-1-1.3 0-.6.1-1.2.1-1.8 0-1.8.6-3.5-.2-5.4-.6-1.3-.2-3-.4-4.6-.2-1.9-.5-3.9-.7-5.8zM449.5 281.1c.8 7.3 1.7 14.5 2.5 21.8.1.8.1 1.6-.9 1.6s-1-.8-1-1.6l-.9-21.3v-.6c.1.1.2.1.3.1zM396.9 257.1c-.1 2.5-.3 5-.4 7.6-.1 4.2-.2 8.4-.3 12.5v.8c0 .7-.3 1.4-1.1 1.3-.8-.1-.9-.7-.9-1.4.3-3.2.6-6.4 1-9.6.5-3.7 1-7.5 1.6-11.2h.1zM461.6 307.8c.7 5.1 1.5 10.2 2.2 15.2.2 1.7.5 3.3.7 5 .1.7-.1 1.4-.9 1.4-.8.1-1-.5-1.1-1.2-.2-5.5-.5-11-.7-16.6-.1-1.3 0-2.6 0-4-.1.2-.1.2-.2.2zM369.5 282.1v8.8c0 3.3.1 6.5.2 9.8v.7c0 .7-.1 1.5-1.1 1.4-.9-.1-.9-.8-.9-1.6.4-5.2.8-10.3 1.2-15.5.3-1.3.5-2.5.6-3.6zM462.7 259.7c.6 5.9 1.3 11.9 1.9 17.8 0 .2.1.3.1.5 0 .6-.1 1.2-.9 1.2-.7 0-1-.4-1-1.1v-5.5c-.1-3.9-.3-7.7-.4-11.6v-1.3h.3zM447.6 239.4c.4 5.3.9 10.6 1.3 15.9.1.8 0 1.5-.9 1.6-.9 0-1-.7-1-1.5.1-5.3.3-10.7.4-16h.2zM385.5 303.7c.3 4.5.6 10.1.9 15.6v.5c0 .7-.1 1.3-.9 1.3s-1-.6-1-1.3c.1-2.6.2-5.3.4-7.9.1-3.1.4-6.1.6-8.2zM445.8 272.7c.3 2.9.7 5.8 1 8.7.2 2.1.2 4.3.3 6.4 0 .7-.1 1.4-1 1.4s-1-.7-1-1.4c.2-4.1.3-8.2.4-12.3 0-.9-.1-1.9-.2-2.9.3.1.4.1.5.1zM430.8 185.5c1.4-2.3 3.3-4 5.9-4.7 1.4-.4 2.6.1 3.1 1.5s.9 2.8 1.2 4.3c.1.3-.5.8-.8 1.2-.4-.3-1-.5-1.1-.9-.2-.9-.2-1.8-.3-2.7-.3-2-1-2.6-2.9-1.9-1.5.6-2.8 1.6-4.2 2.5-.3.1-.6.5-.9.7zM452.1 226.3c.6 4.4 1.3 8.9 1.9 13.3 0 .3.1.6 0 .8-.2.4-.5.7-.8 1.1-.4-.3-.7-.6-1.1-1-.1-.1 0-.3 0-.4-.1-4.6-.1-9.2 0-13.8-.1 0 0 0 0 0zM379.8 203.6c-2.2 4.3-3.7 8.8-4.7 13.5-.1.7-.4 1.4-1.2 1.2-.9-.2-.9-1-.7-1.8 1.6-4.6 3.7-9 6.6-12.9zM470.7 369.6c.1 4.9.3 9.7.4 14.6 0 .2.1.5 0 .7-.3.4-.7.7-1 1-.3-.3-.8-.7-.8-1 0-1.6.2-3.3.3-4.9.4-3.4.8-6.8 1.1-10.2v-.2c0 .1 0 .1 0 0zM442.5 228.8c1.3 3 1.7 6.1 2 9.3.2 1.4.2 2.9.3 4.4.1.7.1 1.5-.9 1.5s-1-.7-1-1.5v-10.8c0-.9-.3-1.9-.4-2.9zM443.5 192.3c2.1 3 3.3 6.5 4.5 9.9.3 1 .6 2.1 1 3.1.3.8.3 1.5-.6 1.7-.9.3-1.2-.5-1.3-1.2-.6-2.7-1.1-5.5-1.7-8.2-.5-1.8-1.3-3.5-1.9-5.3zM448 262.2c.6 4.3 1.1 8.5 1.7 12.8 0 .3.2.7.1.9-.2.4-.7.8-1 1.2-.3-.4-.9-.7-.9-1.2-.1-.9.1-1.9.1-2.9v-10.8zM396.4 184.9c-2.8-.3-4.8 1.3-6.3 3.5-1 1.6-1.8 3.3-2.6 5-.3.7-.6 1.4-1.5 1-.9-.4-.7-1.2-.3-1.9 1.1-1.6 2.1-3.2 3.3-4.7 2-2.3 4.5-3.7 7.4-2.9zM388.5 176.8c-2.6 2.5-4.3 5.5-6.3 8.4-.4.6-.7 1.2-1.2 1.7-.3.3-.9.3-1.4.4-.1-.5-.4-1.2-.2-1.5.5-.8 1.2-1.5 1.8-2.2 1.8-1.9 3.6-3.8 5.4-5.6.6-.6 1.3-.9 1.9-1.2zM429.7 248.7l1.2 12.9c.1.7-.2 1.3-1 1.2-.4-.1-.9-.8-.9-1.2 0-1.3.2-2.7.2-4v-8.8c.2 0 .4-.1.5-.1zM454.2 216.7c.5 1.4 1 2.7 1.4 4.1.6 2.6 1.1 5.2 1.7 7.9.2.7 0 1.4-.8 1.5-.8.1-1.1-.5-1.1-1.3-.3-4.1-.3-8.2-1.2-12.2zM418.5 183.8c-.2-1.2-.4-2.2-.5-3.2-.3-2.2.3-4.2 1.6-6 .7-.9 1.5-1.9 2.3-2.8.4-.5 1-.7 1.5-.2.2.4.3 1.1 0 1.5-.3.5-.9 1-1.4 1.3-2.9 2-3.7 4.9-3.4 8.2 0 .2 0 .5.1.7-.1.1-.1.2-.2.5zM364 367.1v9.5c0 .8.1 1.5.2 2.3.1.7 0 1.5-1 1.5-.9 0-1.1-.7-1-1.5.3-2.6.6-5.2 1-7.8.2-1.4.3-2.7.5-4.1 0 .1.1.1.3.1zM374.5 247.3c-.2 3.5-.3 6.9-.5 10.3 0 .4.1.8-.1 1.1-.2.4-.7 1-1 1.1-.7 0-1-.6-.9-1.3.4-2.1.7-4.2 1.2-6.2.4-1.7.9-3.4 1.3-5zM431.9 194.6c2.7-.9 5-.3 6.8 1.9.7.8 1.2 1.7 1.8 2.5.3.6.2 1.3-.5 1.5-.4.1-.9-.4-1.3-.7-.3-.3-.4-.8-.6-1.2-1.1-2.8-3.1-4.3-6.2-4zM380.1 218c-.3 3.2-.6 6.4-1 9.6 0 .3 0 .8-.2 1-.2.3-.7.7-.9.6-.3-.1-.6-.6-.9-.9-.1-.1 0-.3 0-.5.9-3.3 1.9-6.6 2.8-9.9.1 0 .2 0 .2.1zM455.4 193.1c.6 3.1 1.2 6.1 1.8 9.2 0 .2.1.4 0 .6l-.9 1.2c-.3-.4-.9-.8-.9-1.2-.1-2-.1-4-.1-6v-3.7s0-.1.1-.1zM383.5 229.8c-.2 3.2-.4 6.4-.7 9.5 0 .4-.6.9-1 .9-.8 0-1-.7-.9-1.3.5-2.1 1-4.3 1.5-6.4.2-1 .6-1.9.8-2.8.2.1.3.1.3.1zM413.8 167.4c-1.7-1.3-3.5-1-5.2-.4-.8.2-1.5.8-2.3 1-.4.1-.9-.2-1.4-.2.1-.5.1-1.2.4-1.5 1.7-1.3 6.5-.9 8 .5.2.1.3.4.5.6zM432.3 239.9c.5 2.8 1 5.6 1.4 8.4 0 .4-.5 1.1-.9 1.2-.7.2-1-.4-1-1.2v-8.4c.2.1.4.1.5 0zM384.7 264.1c.3 2.6.6 5.5 1 8.4v.7c0 .7-.3 1.3-1 1.1-.4-.1-.9-.8-.9-1.2 0-1.3.2-2.7.4-4 .1-1.7.3-3.5.5-5zM379.9 340.2c.1 2.8.3 5.5.3 8.3 0 .5-.2 1-.5 1.4-.1.1-.9.1-1-.1-.2-.4-.4-1-.3-1.5.4-2.7.9-5.4 1.5-8.1-.1 0 0 0 0 0zM424.4 175.2c.5-.5.9-1.1 1.4-1.5 1.5-1.2 3.3-1.7 5.3-1.6.5 0 1 .4 1.4.8.2.2 0 1-.2 1.1-.4.2-1 .2-1.5.1-2.2-.7-4.5-.2-6.2 1.4-.1-.2-.2-.2-.2-.3zM475.4 326.9c.4 2.6.9 5.3 1.3 7.9.1.7 0 1.4-.9 1.4s-1-.6-1-1.4c.2-2.6.3-5.3.5-7.9h.1zM419.9 164.3c.8-1 1.4-2.1 2.3-3 1-.9 2.1-1.7 3.2-2.4.4-.2 1-.2 1.5-.1.2 0 .5.7.4 1-.2.4-.6.7-1 1-.2.2-.6.2-.9.3-2.1.7-4 1.6-5.2 3.5l-.3-.3zM444.4 226c1.4 2 2 4.7 2.7 7.4.2.6-.1 1.2-.8 1.3-.8.1-1-.4-1.1-1.1-.2-2.7-.5-5.3-.8-7.6zM438.5 267.3c.6 2.6 1.2 4.9 1.7 7.3.1.4.3.8.2 1.1-.2.4-.5 1-.9 1.1-.7.2-1-.3-1-1v-8.5zM460.6 344.3c.4 2.5.8 4.9 1.1 7.3.1.4-.1 1-.4 1.3-.1.2-.9.2-1 .1-.3-.3-.5-.9-.5-1.3.2-2.5.5-4.9.8-7.4zM438.4 219c1.1 1.9 2.2 3.8 3.3 5.8.2.3.3.6.3 1 0 .5.1 1.1-.7 1.2-.7.1-1.1-.2-1.2-.9-.1-.8-.2-1.7-.4-2.5l-1.2-3.9c-.1-.3-.1-.5-.1-.7zM455.5 308c.3 2.1.7 4 .9 6 .1.4-.1.9-.4 1.2-.2.2-.8.2-1 0-.3-.3-.5-.8-.5-1.2.3-1.9.6-3.9 1-6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBg);
export default __webpack_public_path__ + "static/media/errorBg.ead500bc4ff43f16bcdcde3fcf2ff722.svg";
export { ForwardRef as ReactComponent };